<template>
	<div>
		<div class="hidden-xs-only">
			<el-carousel height="722px" autoplay arrow="never" indicator-position="none">
				<el-carousel-item v-for="(item,index) in info.hourse_info.pictureimages" :key="index">
					<img :src="item" class="width-100 h-722" mode="widthFix" />
				</el-carousel-item>
			</el-carousel>

			<div class="d-flex-center bgc-f4f4f4">
				<div class="w-80p d-flex-row p-t-30">
					<div ref="obtain" class="w-70p m-r-35">
						<div class="bgc-white p-25">
							<div class="f-20 c-00 font-weight-bold">{{info.hourse_info.address_infor}}</div>
							<div class="f-14 c-66 m-t-20">
								{{info.hourse_info.administrative_regionlist}} | {{info.hourse_info.measure_area}}平方米
							</div>
							<div class="f-14 c-66 m-t-20">
								地址：{{info.hourse_info.address}}
							</div>
							<div class="d-flex-between">
								<div class="f-14 c-66 m-t-20 d-flex-row">
									<img v-if="info.hourse_info.sharing_status=='合'"
										src="../../assets/image/index/h-1.png" class="w-38 h-18 m-r-5" />
									<img v-if="info.hourse_info.sharing_sex=='女'" src="../../assets/image/index/h-2.png"
										class="w-38 h-18 m-r-5" />
									<!-- <img src="../../assets/image/index/h-3.png" class="w-76 h-18" /> -->
								</div>
								<div class="c-FC312A">
									<span class="f-36 font-weight-bold">¥{{info.hourse_info.now_price}}</span>
									<span class="f-24">/月</span>
								</div>
							</div>
						</div>

						<div class="bgc-white p-25 m-t-10">
							<div class="f-20 c-00 font-weight-bold m-b-40">房屋配套</div>
							<div class="d-flex-wrap w-90p">
								<div v-for="(item,index) in apartment" :key="index" class="w-100 m-t-40">
									<div class="d-flex-center">
										<img :src="item.img" class="w-30 h-30" />
									</div>
									<div class="d-flex-center m-t-15">{{item.name}}</div>
								</div>
							</div>
						</div>

						<div class="f-20 c-00 font-weight-bold m-t-30 m-b-25">房源周边</div>
						<div class="m-t-25">
							<div class="bm-view">
								<baidu-map class="bm-view" :center="center" :zoom="zoom" @ready="handler">
									<bm-marker :position="center" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
									</bm-marker>
									<bm-info-window :position="center" :show="infoWindow.show" @close="infoWindowClose"
										@open="infoWindowOpen">
										<p v-text="infoWindow.name" class="f-14 c-00 m-t-10"></p>
										<p v-text="infoWindow.text" class="f-12 c-99 m-t-10"></p>
									</bm-info-window>
								</baidu-map>
								<!-- <div class="w-225 h-320 fu11">
									<div class="width-100 d-flex-row">
										<div v-for="(item,index) in tab" :key="index" @click="choice(index)"
											:class="tnav==index?'bgc-white':'bgc-E5EBF1'"
											class="d-flex-center d-flex-items-center w-25p f-14 c-33 h-33">
											{{item}}
										</div>
									</div>
									<div class="width-100 bgc-white over h-250">
										<div @click="selectmap(index,item.center,item)" v-for="(item,index) in matching"
											:key="index" class="p-10">
											<div class="b-b d-flex-row p-b-10 d-flex-items-center">
												<img :src="mnav==index? require('@/assets/image/housing/r.png'):require('@/assets/image/housing/b.png')"
													class="w-15 h-15 m-r-15" />
												<div class="">
													<div class="f-12 c-00">{{item.name}}</div>
													<div class="f-12 c-99 m-t-5">{{item.text}}</div>
												</div>
											</div>
										</div>
									</div>
								</div> -->
							</div>
						</div>

						<div class="f-20 c-00 font-weight-bold m-b-40 m-t-60 d-flex-between">
							<div class="f-20 c-00 font-weight-bold m-b-25">公寓其他房型</div>
							<div class="d-flex-row">
								<!-- <div class="m-r-15 w-25 h-25 bgce5e6e7 d-flex-center d-flex-items-center">
									<i class="el-icon-arrow-left"></i>
								</div>
								<div class="w-25 h-25 bgce5e6e7 d-flex-center d-flex-items-center">
									<i class="el-icon-arrow-right"></i>
								</div> -->
							</div>
						</div>

						<div class="m-b-165 warp" @click="handleButton($event)"
							style="overflow-x:scroll;overflow: hidden;">
							<!-- <vue-seamless-scroll :data="room" :class-option="classOption" class="warp"> -->
							<ul class="ul-item width-100 d-flex-row" style="overflow: auto;">
								<li class="li-item b-all-C9C6C6 w-300" @click="dian(item.house_id)"
									v-for="(item, index) in info.hourse_list" :key="index">
									<img :src="item.image" class="width-100 h-220" />
									<div class="bgc-white p-t-10 p-l-25 p-r-25 w-300">
										<div class="f-20 c-33 font-weight-bold">{{item.name}}</div>
										<div class="f-16 c-66 m-t-10">
											<span>{{item.house_type}}</span>
											<span class="m-r-10 m-l-10">|</span>
											<span>{{item.measure_area}}</span>
										</div>
										<div class="f-20 c-EC4738 m-t-20 p-b-30">￥{{item.now_price}}/月</div>
									</div>
								</li>
							</ul>
							<!-- </vue-seamless-scroll> -->
						</div>

						<!-- <div class="width-100 d-flex-center m-b-165">
							<div v-for="(item,index) in room" :key="index" :class="index !=2? 'm-r-40':''"
								class="b-all-C9C6C6 width-33">
								<img :src="item.img" class="width-100 h-220" />
								<div class="bgc-white p-t-10 p-l-25 p-r-25">
									<div class="f-20 c-33 font-weight-bold">{{item.name}}</div>
									<div class="f-16 c-66 m-t-10">
										<span>{{item.room}}</span>
										<span class="m-r-10 m-l-10">|</span>
										<span>{{item.size}}</span>
									</div>
									<div class="f-20 c-EC4738 m-t-20 p-b-30">￥{{item.price}}/月</div>
								</div>
							</div>
						</div> -->
					</div>

					<!-- 预约看房 -->
					<div :class="float? 'fu1':''" class="w-410 h-780 b-all-05407B p-30 bgc-white">
						<div class="f-24 c-5A81A8 font-weight-bold b-b-346293 lh-50">预约看房</div>
						<div class="f-14 c-99 m-t-10">
							<span class="m-r-20">预约看房时间:</span>
							<span>上午08:00至下午17:00</span>
						</div>
						<div class="m-t-35 d-flex-row">
							<div class="w-100p">
								<el-date-picker style="width: 100%;" class="b-all-05407B" v-model="value1"
									placeholder="选择日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd">
								</el-date-picker>
							</div>
						</div>
						<div class="m-t-10 w-100p">
							<div class="w-100p m-r-15 b-all-05407B">
								<el-input v-model="surname" placeholder="请输入您的姓氏"></el-input>
							</div>
						</div>
						<div class="m-t-10">
							<el-dropdown @command="select" class="b-all-05407B w-100p">
								<span class="el-dropdown-link p-10 f-14 c-99 d-flex-between d-flex-items-center">
									{{pattern==""? '选择租房类型':pattern}}
									<i class="el-icon-caret-bottom el-icon--right c-D8D8D8"></i>
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="1">合租</el-dropdown-item>
									<el-dropdown-item command="4">整租</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
						<div class="m-t-10 b-all-05407B">
							<el-input v-model="tel" placeholder="请输入您的电话"></el-input>
						</div>

						<div class="b-all-1D5189 m-t-10 p-15">
							<div class="f-14 c-99">请填写备注</div>
							<textarea v-model="remark" class="bgc-F1F1F1 m-t-10 p-15 h-100 bgc-ee width-100">
							</textarea>
						</div>

						<div @click="autograph=!autograph"
							class="m-t-20 bgc-1D5189 c-white h-44 d-flex-center d-flex-items-center">
							签名
						</div>

						<div v-if="autograph" class="btnlistbox">
							<sign-canvas class="sign-canvas" ref="SignCanvas" :options="options" v-model="value" />
							<div class="btnList" ref="btnList">
								<div class="m-l-30 m-r-30 bgc-1D5189 c-white p-10" type="danger" v-throttle size="small"
									@click="clearSignImg">清空</div>
								<div type="primary" v-throttle size="small"
									class="m-l-30 m-r-30 bgc-1D5189 c-white p-10" @click="saveSignImg">保存
								</div>
							</div>
						</div>

						<div @click="appoi" class="m-t-20 bgc-1D5189 c-white h-44 d-flex-center d-flex-items-center">
							立即预约看房
						</div>
						<div class="m-t-30 d-flex-row d-flex-items-center">
							<img src="@/assets/image/housing/tel.png" class="w-22 h-22 m-r-15" />
							<div class="f-14 c-5A81A8">预约管家电话：</div>
						</div>
						<div class="f-22 c-5A81A8 m-t-10">
							{{contact_tel}}
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="hidden-sm-and-up">
			<el-carousel height="300px" autoplay arrow="never" indicator-position="none">
				<el-carousel-item v-for="(item,index) in info.hourse_info.pictureimages" :key="index">
					<img :src="item" class="width-100 h-300" mode="widthFix" />
				</el-carousel-item>
			</el-carousel>

			<div class="bgc-white p-30">
				<div class="f-20 c-00 font-weight-bold">{{info.hourse_info.address_infor}}</div>
				<div class="m-t-20 d-flex-row d-flex-items-center">
					{{info.hourse_info.administrative_regionlist}} | {{info.hourse_info.measure_area}}平方米
				</div>
				<div class="m-t-20 d-flex-row d-flex-items-center">
					地址：{{info.hourse_info.address}}
				</div>
				<div class="m-t-20 d-flex-row d-flex-items-center c-EA4638">
					<span class="f-24 font-weight-bold">¥{{info.hourse_info.now_price}}</span>
					<span class="f-14">/月</span>
				</div>
			</div>
			<div class="bgc-white p-25 m-t-10">
				<div class="f-20 c-00 font-weight-bold m-b-20">房屋配套</div>
				<div class="d-flex-wrap w-100p">
					<div v-for="(item,index) in apartment" :key="index" class="w-108 p-t-40">
						<div class="d-flex-center">
							<img :src="item.img" class="w-30 h-30" />
						</div>
						<div class="d-flex-center m-t-15">{{item.name}}</div>
					</div>
				</div>
			</div>
			<div class="bgc-white p-25 m-t-10">
				<div class="f-20 c-00 font-weight-bold m-b-20">周边交通配套</div>
				<div class="m-t-25">
					<div class="bm-view1">
						<baidu-map class="bm-view1" :center="center" :zoom="zoom" @ready="handler">
							<bm-marker :position="center" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
							</bm-marker>
							<bm-info-window :position="center" :show="infoWindow.show" @close="infoWindowClose"
								@open="infoWindowOpen">
								<p v-text="infoWindow.name" class="f-14 c-00 m-t-10"></p>
								<p v-text="infoWindow.text" class="f-12 c-99 m-t-10"></p>
							</bm-info-window>
						</baidu-map>
						<!-- <div class="d-flex-center">
							<div class="w-300 fu2">
								<div class="width-100 d-flex-row">
									<div v-for="(item,index) in tab" :key="index" @click="choice(index)"
										:class="tnav==index?'bgc-white':'bgc-E5EBF1'"
										class="d-flex-center d-flex-items-center w-25p f-14 c-33 h-33">
										{{item}}
									</div>
								</div>
								<div class="width-100 bgc-white over h-140">
									<div @click="selectmap(index,item.center,item)" v-for="(item,index) in matching"
										:key="index" class="p-10 b-b">
										<div class="d-flex-row d-flex-items-center">
											<img :src="mnav==index? require('@/assets/image/housing/r.png'):require('@/assets/image/housing/b.png')"
												class="w-15 h-15 m-r-15" />
											<div class="">
												<div class="f-12 c-00">{{item.name}}</div>
												<div class="f-12 c-99 m-t-5">{{item.text}}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div> -->
					</div>
				</div>
			</div>
			<div class="bgc-white p-25 m-t-10">
				<div class="f-20 c-00 font-weight-bold m-b-20">其他房型</div>
				<list-box @choose="" :list="info.hourse_list"></list-box>
			</div>
			<div class="bgc-white p-25 m-t-10">
				<div class="f-20 c-00 font-weight-bold m-b-10">预约看房</div>
				<div class="f-14 c-99">预约看房时间： 上午08:00至下午17:00</div>
				<div class="b-all-1D5189 m-t-30 p-15 h-60 d-flex-items-center d-flex-between">
					<div class="f-14 c-33">选择日期</div>
					<el-date-picker v-model="value1" type="date" placeholder="选择日期" prefix-icon="none"
						:picker-options="pickerOptions" value-format="yyyy-MM-dd">
					</el-date-picker>
				</div>

				<div class="b-all-1D5189 m-t-10 p-15 d-flex-between h-60 d-flex-items-center">
					<div class="f-14 c-33">您的姓氏</div>
					<el-input v-model="surname" :clearable="true" placeholder="输入您的姓氏" class="w-200" size="mini">
					</el-input>
				</div>

				<div class="b-all-1D5189 m-t-10 p-15 d-flex-between h-60 d-flex-items-center">
					<div class="f-14 c-33">租房类型</div>
					<el-dropdown @command="select" class="w-60p">
						<span class="el-dropdown-link f-14 c-99 d-flex-between d-flex-items-center">
							<span class="m-r-10">{{pattern==""? '选择租房类型':pattern}}</span>
							<i class="el-icon-caret-bottom el-icon--right c-D8D8D8"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="1">合租</el-dropdown-item>
							<el-dropdown-item command="4">整租</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>

				<div class="b-all-1D5189 m-t-10 p-15 d-flex-between h-60 d-flex-items-center">
					<div class="f-14 c-33">您的电话</div>
					<el-input v-model="tel" :clearable="true" placeholder="输入您的电话" class="w-200" size="mini"></el-input>
				</div>

				<div class="b-all-1D5189 m-t-10 p-15">
					<div class="f-14 c-99">请填写备注</div>
					<textarea v-model="remark" class="bgc-F1F1F1 m-t-10 p-15 h-100 bgc-ee width-100">
					</textarea>
				</div>

				<div @click="autograph1=!autograph1"
					class="m-t-20 bgc-1D5189 c-white h-44 d-flex-center d-flex-items-center br-5">
					签名
				</div>

				<div v-if="autograph1" class="sign">
					<sign-canvas class="sign-canvas1" ref="SignCanvas" :options="options" v-model="value" />
					<div class="btnList1 d-flex-row d-flex-center m-t-20" ref="btnList">
						<div class="m-l-30 m-r-30 bgc-1D5189 c-white p-10" type="danger" v-throttle size="small"
							@click="clearSignImg">清空</div>
						<div type="primary" v-throttle size="small" class="m-l-30 m-r-30 bgc-1D5189 c-white p-10"
							@click="saveSignImg">保存
						</div>
					</div>
				</div>


				<div @click="appoi" class="m-t-20 bgc-1D5189 c-white h-44 d-flex-center d-flex-items-center br-5">
					立即预约看房
				</div>

				<div class="m-t-30 d-flex-row d-flex-items-center">
					<img src="@/assets/image/housing/tel.png" class="w-22 h-22 m-r-15" />
					<div class="f-14 c-5A81A8">预约管家电话：</div>
				</div>
				<div class="f-22 c-5A81A8 m-t-10 font-weight-bold">
					{{contact_tel}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import vueSeamlessScroll from 'vue-seamless-scroll'
	import listBox from '@/components/list.vue'
	import SignCanvas from "sign-canvas";
	import {
		Loading
	} from 'element-ui';
	import {
		list,
		apartment,
		room,
		matching,
		list1
	} from './config/index.js'
	export default {
		components: {
			vueSeamlessScroll,
			listBox,
			SignCanvas
		},
		data() {
			return {
				list: list,
				list1: list1,
				apartment: apartment,
				room: room,
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now();
					},
				},
				value1: '',
				value2: [new Date(2016, 9, 10, 8, 0), new Date(2016, 9, 10, 17, 0)],
				tel: "",
				surname: "",
				float: false,
				classOption: {
					limitMoveNum: 2,
					switchSingleStep: 140,
					direction: 3,
					// switchOffset: 50,
					// navigation: true,
					// autoPlay: false,
				},
				patternname: '',
				timeslot: '',
				center: {
					lng: 116.404,
					lat: 39.915
				},
				zoom: 3,
				tab: ['公交', '商业', '教育', '医疗'],
				matching: matching,
				infoWindow: {
					show: false,
					text: '',
					name: ''
				},
				mnav: 0,
				tnav: 0,
				info: {
					hourse_info: {},
					hourse_list: {}
				},
				contact_tel: "",
				house_id: '',
				pattern: "",

				// 签名
				value: null,
				options: {
					lastWriteSpeed: 1, //书写速度 [Number] 可选
					lastWriteWidth: 2, //下笔的宽度 [Number] 可选
					lineCap: "round", //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]	正方形线帽
					lineJoin: "round", //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
					canvasWidth: "750", //canvas宽高 [Number] 可选
					canvasHeight: "500", //高度  [Number] 可选
					isShowBorder: false, //是否显示边框 [可选]
					bgColor: "#fcc", //背景色 [String] 可选
					borderWidth: 1, // 网格线宽度  [Number] 可选
					borderColor: "#ff787f", //网格颜色  [String] 可选
					writeWidth: 5, //基础轨迹宽度  [Number] 可选
					maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
					minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
					writeColor: "#101010", // 轨迹颜色  [String] 可选
					isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
					imgType: "png", //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
				},
				autograph: false,
				img_url: '',
				autograph1: false,
				remark: ''
			}
		},
		mounted() {
			this.getinfo(this.$route.query.house_id)
			this.house_id = this.$route.query.house_id;
			this.contact_tel = window.localStorage.getItem('contact_tel');
			window.addEventListener('scroll', this.handleScrollx, true)

			// 签名
			let windowHeight = document.documentElement.clientHeight;
			let btnList = this.$refs.btnList.offsetHeight;
			let windowWidth = document.documentElement.clientWidth;
			this.options.canvasWidth = windowWidth;
			this.options.canvasHeight = windowHeight - btnList;

		},
		methods: {
			//清除画板
			clearSignImg() {
				this.$refs.SignCanvas.canvasClear();
			},
			// 保存图片
			saveSignImg() {
				console.log(this.value, "value");
				if (this.value == null) {
					this.$message.error("请先签名")
				} else {
					const img = this.$refs.SignCanvas.saveAsImg();
					this.signShipmentsContractFun(img);
				}
			},
			async signShipmentsContractFun(img) {
				const loading = this.$loading({
					lock: true,
					text: '正在保存...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				const res = await this.$service.post({
					url: '/api/app/v1/app_upload_bse64_img',
					data: {
						base64_img: img
					}
				})
				if (res.code == 1) {
					this.img_url = res.info.img_url;
					this.$message.success("保存成功")
					this.autograph1 = false;
					this.autograph = false;
					this.$nextTick(() => {
						loading.close();
					}, 2000);
				} else {
					this.$message.error(res.msg)
				}
			},
			async appoi() {
				if (this.value1 == "") {
					this.$message.error('请选择日期')
					return
				}
				if (this.surname == "") {
					this.$message.error('请填写您的姓氏')
					return
				}
				if (this.patternname == "") {
					this.$message.error('请选择租房类型')
					return
				}
				if (this.tel == "") {
					this.$message.error('请填写您的电话')
					return
				}
				const myreg = /^1[3-9]\d{9}$/;
				if (!myreg.test(this.tel)) {
					this.$message.error('手机号格式不正确')
					return
				}

				if (this.img_url == "") {
					this.$message.error("请先签名")
					return
				}

				// if (this.remark == "") {
				// 	this.$message.error("请填写备注")
				// 	return
				// }

				const res = await this.$service.post({
					url: '/api/web/v1/app_booking_hourse',
					data: {
						hid: this.house_id,
						appointment_time: this.value1,
						appointment_name: this.surname,
						appointment_mobile: this.tel,
						reservation_statuslist: this.patternname,
						sign_confirmation: this.img_url,
						remark: this.remark
					}
				})
				if (res.code == 1) {
					this.$message.success("预约成功,请等待...")
					return
				} else {
					this.$message.error(res.msg)
				}
			},
			async getinfo(house_id) {
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});

				const res = await this.$service.post({
					url: '/api/web/v1/app_get_room_info',
					data: {
						hid: house_id
					}
				})
				this.info = res.info;
				this.center = res.info.hourse_info.address_info_location;
				this.$nextTick(() => {
					loading.close();
				}, 2000);
			},
			handleButton(e) {},
			dian(house_id) {
				this.$router.push({
					path: "/introduce",
					query: {
						house_id: house_id
					}
				});
				this.getinfo(house_id)
			},
			choice(index) {
				this.tnav = index;
			},
			handler({
				BMap,
				map
			}) {
				this.center.lng = 116.404
				this.center.lat = 39.915
				this.zoom = 15
			},
			infoWindowClose(e) {
				this.infoWindow.show = false
			},
			infoWindowOpen(e) {
				this.infoWindow.show = true
			},
			clear() {
				this.infoWindow.contents = ''
			},
			selectmap(index, center, item) {
				this.mnav = index;
				this.center = center;
				this.infoWindow.show = true;
				this.infoWindow.text = item.text;
				this.infoWindow.name = item.name;
			},
			select(e) {
				this.patternname = e;
				if (e == 1) {
					this.pattern = "合租"
				} else {
					this.pattern = "这样组"
				}
			},
			stime(e) {
				this.timeslot = e;
			},
			handleScrollx() {
				// console.log('滚动高度', window.pageYOffset)
				// console.log('距离顶部高度', this.$refs.obtain.getBoundingClientRect().top)
				if (this.$refs.obtain.getBoundingClientRect().top < 220) {
					this.float = true
				} else {
					this.float = false
				}
			}
		},
		beforeDestroy() {
			// document.removeEventListener('scroll', this.handleScroll,true)
			window.removeEventListener('scroll', this.handleScroll, true)
		},
	}
</script>

<style lang="scss" scoped>
	.bm-view {
		width: 100%;
		height: 350px;
	}

	.bm-view1 {
		width: 100%;
		height: 420px;
	}

	.fu11 {
		position: relative;
		left: 70%;
		top: -320px;
	}

	.fu2 {
		position: relative;
		top: -180px;
	}

	.fu {
		position: absolute;
		left: 70%;
		z-index: 2;
		bottom: 0;
	}

	.bgc {
		background: rgba(0, 0, 0, 0.66);
	}

	.c-FCE3C0 {
		color: #FCE3C0;
	}

	.bgc-FCE3C0 {
		background: #FCE3C0;
	}

	.c-965E1C {
		color: #965E1C;
	}

	.bgce5e6e7 {
		background: #e5e6e7;
		color: #797979;
	}

	.bgce5e6e7:hover {
		background: #1d5189;
		color: #ffffff;
	}

	.b-all-05407B {
		border: 1px solid #05407B;
	}

	.c-5A81A8 {
		color: #5A81A8;
	}

	.b-b-346293 {
		border-bottom: 3px solid #346293;
	}

	.bgc-1D5189 {
		background: #1D5189;
	}

	.fu1 {
		position: fixed;
		top: 10%;
		left: 67%;
		z-index: 9;
	}

	.over {
		overflow-y: scroll;
	}

	/* // 滚动条本体，要想设置滚动条样式，需要先设置该元素 */
	::-webkit-scrollbar {
		height: 6px;
		width: 6px;
	}

	/* // 滚动条滑块 */
	::-webkit-scrollbar-thumb {
		background-color: #eee;
		border-radius: 3px;
	}

	.warp {
		// width: 130px * 4 - 10;
		// height: 356px;
		margin: 0 auto;
		overflow: hidden;

		ul {
			list-style: none;
			padding: 0;
			margin: 0 auto;

			&.ul-item {
				display: flex;

				.li-item {
					// width: 120px;
					// height: 120px;
					margin-right: 10px;
					// line-height: 120px;
					// background-color: #999;
					// color: #fff;
					// text-align: center;
					// font-size: 30px;
				}
			}
		}
	}

	.c-1D5189 {
		color: #1D5189;
	}

	.btnlistbox {
		position: fixed;
		z-index: 999999;
		top: 15vh;
		right: 30vw;
	}

	.btnList {
		display: flex;
		justify-content: center;
		margin-top: -80px;
	}

	.sign-canvas {
		display: block;
		margin: 0 auto;
		background: #F1F1F1 !important;
		border-radius: 8px;
		border: 1px solid #05407B;
	}


	.btnList1 {
		// position: fixed;
		// right: 40%;
		// width: 50%;
		// padding: 30px 0;
		// display: flex;
		// justify-content: center;
		// margin-top: 500px;

	}

	.sign-canvas1 {
		width: 100% !important;
		background: #F1F1F1 !important;
		height: 300px;
		margin-top: 20px;
	}

	.bgc-F1F1F1 {
		background: #F1F1F1 !important;
	}
</style>
<style>
	.el-input__inner {
		border: none !important;
	}
</style>
